import { BUILD_ENVIRONMENTS } from '@src/config/constants'
import { API_SF_RUNTIME_BASE_URL, CONFIG_BUILD_ENV } from '@src/config/env'

// @i18n-ignore
const ENV_PARAM_KEY = 'environment'
// @i18n-ignore
const ENV_PARAM_VALUE_FOR_STAGING = 'staging'
const VALID_ENVS_FOR_FORMATTING = [
  BUILD_ENVIRONMENTS.STAGE.valueOf(),
  BUILD_ENVIRONMENTS.DEV.valueOf(),
  BUILD_ENVIRONMENTS.QA.valueOf(),
]

const getFormattedUrlForStorefrontRuntimeApi = (requestUrl?: string): string | undefined => {
  const isUrlStorefrontRuntimeApi =
    requestUrl && API_SF_RUNTIME_BASE_URL && requestUrl.includes(API_SF_RUNTIME_BASE_URL)
  const isEnvValidForFormatting = CONFIG_BUILD_ENV && VALID_ENVS_FOR_FORMATTING.includes(CONFIG_BUILD_ENV)
  if (isUrlStorefrontRuntimeApi && isEnvValidForFormatting) {
    const currentUrl = new URL(requestUrl)
    const currentUrlEnvVal = currentUrl.searchParams.get(ENV_PARAM_KEY)
    if (!currentUrlEnvVal) {
      currentUrl.searchParams.append(ENV_PARAM_KEY, ENV_PARAM_VALUE_FOR_STAGING)
    } else if (currentUrlEnvVal !== ENV_PARAM_VALUE_FOR_STAGING) {
      currentUrl.searchParams.set(ENV_PARAM_KEY, ENV_PARAM_VALUE_FOR_STAGING)
    }
    return currentUrl.href
  }
  return requestUrl
}

const getFormattedUrlForEnv = (requestUrl?: string): string | undefined => {
  return getFormattedUrlForStorefrontRuntimeApi(requestUrl)
}

export default getFormattedUrlForEnv
